<template>
    <div class="content content-pb">
        <h3>Kontaktiere uns</h3>

        <p>
            <img class="phone" src="phone.png" alt="Telefon">
            <b>
            <a href="tel:050 22 798 9000">050 22 798 9000</a>
            <span class="seperator"></span>
            <a href="mailto:info@herdenschutz.net">info@herdenschutz.net</a>
            </b>
        </p>

        <p>
            Telefonisch sind wir von Montag - Samstag zwischen 08:00 und 19:00 Uhr erreichbar.
        </p>

        <form ref="form" :class="{'first_action': first_action}">
            <div class="input">
                <label for="txt_name">Name</label>
                <input type="text" id="txt_name" v-model="name" required :disabled="is_sending">
            </div>

            <div class="input">
                <label for="txt_email">E-Mail</label>
                <input type="email" id="txt_email" v-model="email" required :disabled="is_sending">
            </div>

            <div class="input">
                <label for="txt_phone">Telefon</label>
                <input type="tel" id="txt_phone" v-model="phone" :disabled="is_sending">
            </div>

            <div class="input mobil">
                <label for="txt_animal">Tierart</label>
                <input type="text" id="txt_animal" v-model="animal" :disabled="is_sending">
            </div>

            <div class="input mobil">
                <label for="txt_available">Beste Erreichbarkeit (Uhrzeit)</label>
                <input type="text" id="txt_available" v-model="available" :disabled="is_sending">
            </div>

            <div class="input large">
                <label for="txt_message">Nachricht</label>
                <textarea id="txt_message" v-model="message" required :disabled="is_sending"></textarea>
            </div>

            <div class="input desktop">
                <label for="txt_animal2">Tierart</label>
                <input type="text" id="txt_animal2" v-model="animal" :disabled="is_sending">
            </div>

            <div class="input desktop">
                <label for="txt_available2">Beste Erreichbarkeit (Uhrzeit)</label>
                <input type="text" id="txt_available2" v-model="available" :disabled="is_sending">
            </div>

            <div class="input">
                <button type="button" @click="sendMail" :disabled="is_sending">
                    <span v-if="is_sending">wird gesendet...</span>
                    <span v-else>Senden</span>
                </button>
            </div>
        </form>
    </div>
</template>


<style scoped>
h3 {
    text-align: center;
    margin-bottom: 0;
}

h3:after {
    content: none;
    background: none;
}

div.content > div {
    margin: -1em;
}

div.input {
    width: calc(100% / 3);
    padding: 0 1em;
    float: left;
    margin-top: 2em;
}

div.input.large {
    width: calc((100% / 3) * 2);
}

label {
    display: block;
    font-size: .8em;
    padding: 1em 0;
    height: 3.14em;
}

input,
textarea {
    background: #F6F6F6;
    box-shadow: .1em .1em .4em #ccc; 
    border: none;
    border-radius: 0;
    padding: .8em;
    width: 100%;
    font-size: 1em;
    font-family: inherit;
    -webkit-appearance: none;
    height: 2.8em;
}

textarea {
    height: 20em;
}

form.first_action input:invalid,
form.first_action textarea:invalid {
    border: thin solid #ff0000;
}

button {
    text-transform: uppercase;
    padding: .8em;
    background: #333333;
    color: #ffffff;
    border: none;
    border-radius: 0;
    font-weight: bold;
    font-size: 1em;
    margin-top: 5em;
    height: 3em;
}

button[disabled] {
    background: #666;
    text-transform: none;
}

div.content p {
    width: 100%;
    text-align: center;
    font-size: 2em;
}

img.phone {
    height: 1em;
    margin-bottom: -.1em;
    margin-right: .2em;
}

span.seperator {
    display: inline-block;
    width: 6em;
    height: .1em;
    background: #3E3E3E;
    border-radius: 1em;
    margin: 0 1em;
    margin-bottom: .28em;
}

@media only screen and (max-width: 760px) {
    div.input {
        float: none;
        clear: both;
    }

    div.input,
    div.input.large {
        width: 100%;
    }

    label {
        font-size: 1.2em;
    }

    button {
        font-size: 1.4em;
        display: block;
        margin: 0 auto;
        margin-top: 3em;
    }
}
</style>

<script>
export default {
    data: () => {
        return {
            first_action: false,
            is_sending: false,
            name: "",
            email: "",
            phone: "",
            message: "",
            animal: "",
            available: ""
        }
    },
    methods: {
        sendMail: function(){
            var $this = this;

            if(!$this.is_sending){
                $this.first_action = true;

                if($this.$refs.form.reportValidity()) {
                    $this.is_sending = true;

                    $this.axios.post('https://api.herdenschutz.net/static/contact/mail', {
                        from: $this.email,
                        name: $this.name,
                        text: $this.message,
                        tel: $this.phone,
                        animal: $this.animal,
                        reach: $this.available
                    }).then(response => {
                        if(response.status == 200){
                            alert('Nachricht erfolgreich versendet.');
                            $this.email = '';
                            $this.name = '';
                            $this.message = '';
                            $this.phone = '';
                            $this.animal = '';
                            $this.available = '';
                            $this.first_action = false;
                        }else{
                            alert('Leider konnte Ihre Nachricht nicht versendet werden. Bitte versuchen Sie es später erneut.');
                        }

                        $this.is_sending = false;
                    });
                }
            }
        }
    }
}
</script>
